// extracted by mini-css-extract-plugin
export default {"articlesGrid":"News_articlesGrid__afBe0"};